import { useState } from "react";
import SimpleMdeReact from "react-simplemde-editor";
import { Button, Col, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Add, Cancel, CategoryName, CreateCategoryTitle, Href, MdeEditorText } from "../../../../../../constants";

// This component allows users to create a new category through a modal form.
const CreateCategory = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <Col xs="12">
      <div className="category-button"> 
        <Button color="transparent" tag="a" className="button-primary bg-light-primary font-primary" href={Href} onClick={toggle}>
          <i className="me-2 fa fa-plus"/>
          {CreateCategoryTitle}
        </Button>
      </div> 
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{CreateCategoryTitle}</ModalHeader>
        <ModalBody className="custom-input">
          <div className="create-category">
            <Label for="validationServer01">
              {CategoryName} <span className="text-danger"> *</span>
            </Label>
            <Input className="m-0" id="validationServer01" type="text" required />
            <div id="editor3" className="mt-2">
              {/* Markdown Editor for category description */}
              <SimpleMdeReact id="editor_container" placeholder={MdeEditorText} options={{ autofocus: true, spellChecker: false }} />
            </div>
            <p className="f-light">Improve product visibility by adding a compelling description.</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="light" className="font-dark" onClick={toggle}>
            {Cancel}
          </Button>
          <Button color="primary" onClick={toggle}>
            {Add}
          </Button>
        </ModalFooter>
      </Modal>
    </Col>
  );
};

export default CreateCategory;
